export const webProgramming = {
  is: {
    title: "Öflug og áreiðanleg vefþróun",
    description: "Við þróum sérsniðnar veflausnir með nýjustu tækni og bestu aðferðum fyrir hámarks árangur.",
    featuresTitle: "Tæknilegar lausnir í fremstu röð",
    featuresDescription: "Við bjóðum upp á fjölbreyttar forritunarlausnir fyrir allar þínar þarfir",
    features: {
      customProgramming: {
        title: "Sérsniðin forritun",
        description: "Við forritum lausnir sem eru sérstaklega hannaðar fyrir þínar þarfir."
      },
      backend: {
        title: "Öflug bakendakerfi",
        description: "Við byggum traust og skalanlegt bakendakerfi fyrir þína veflausn."
      },
      cloud: {
        title: "Skýjalausnir",
        description: "Við nýtum nýjustu tækni í skýjaþjónustum fyrir hámarks afköst."
      },
      security: {
        title: "Öryggi í fyrirrúmi",
        description: "Við tryggjum öryggi gagna og kerfa með bestu aðferðum."
      },
      api: {
        title: "API þróun",
        description: "Við þróum öflug API fyrir samþættingu við önnur kerfi."
      },
      performance: {
        title: "Hraði og afköst",
        description: "Við leggjum áherslu á hraðvirk og skilvirk kerfi."
      }
    },
    technologiesTitle: "Tæknistakkurinn okkar",
    technologiesDescription: "Við notum nýjustu tækni og verkfæri til að skapa bestu mögulegu lausnir",
    technologies: {
      frontend: {
        title: "Framendaþróun",
        description: "React, Next.js, Vue.js, TypeScript, Tailwind CSS"
      },
      backend: {
        title: "Bakendaþróun",
        description: "Node.js, Python, PostgreSQL, MongoDB"
      },
      cloud: {
        title: "Skýjalausnir",
        description: "AWS, Google Cloud, Azure, Vercel"
      },
      database: {
        title: "Gagnagrunnar",
        description: "PostgreSQL, MySQL, MongoDB, Redis"
      },
      devops: {
        title: "DevOps",
        description: "Docker, Kubernetes, CI/CD, Git"
      }
    },
    processTitle: "Þróunarferli okkar",
    processDescription: "Við fylgjum reyndu og traustu ferli til að tryggja árangursríka veflausn",
    process: {
      step1: {
        title: "Greining og skipulagning",
        description: "Við greinum þarfir þínar og skipuleggjum verkefnið í smáatriðum."
      },
      step2: {
        title: "Hönnun og þróun",
        description: "Við hönnun og þróum veflausnina samkvæmt þínum þörfum."
      },
      step3: {
        title: "Prófanir og gæðaeftirlit",
        description: "Við prófum allar lausnir gaumgæfilega til að tryggja gæði og áreiðanleika."
      },
      step4: {
        title: "Útgáfa og eftirfylgni",
        description: "Við gefum út lausnina og veitum áframhaldandi stuðning."
      }
    },
    benefitsTitle: "Ávinningur af sérsmíðuðum lausnum",
    benefitsDescription: "Sérsmíðaðar lausnir skapa samkeppnisforskot og hámarks skilvirkni",
    benefits: {
      benefit1: {
        title: "Sérsniðið að þínum þörfum",
        description: "Lausnir sem hannaðar eru sérstaklega fyrir þitt fyrirtæki."
      },
      benefit2: {
        title: "Skalanleiki",
        description: "Kerfi sem geta vaxið með þínu fyrirtæki án vandkvæða."
      },
      benefit3: {
        title: "Samþætting",
        description: "Auðveld samþætting við núverandi kerfi og verkferla."
      },
      benefit4: {
        title: "Samkeppnisforskot",
        description: "Sérlausnir geta veitt fyrirtæki þínu samkeppnisforskot."
      },
      benefit5: {
        title: "Betri notendaupplifun",
        description: "Sérsniðin viðmót sem henta þínum notendum fullkomlega."
      },
      benefit6: {
        title: "Kostnaðarhagkvæmni",
        description: "Minni heildarrekstrarkostnaður til lengri tíma litið."
      }
    },
    cta: {
      title: "Tilbúin að hefja þitt verkefni?",
      description: "Láttu okkur hjálpa þér að þróa öfluga og áreiðanlega veflausn sem uppfyllir þínar þarfir",
      button: "Fá tilboð í þróun"
    }
  },
  en: {
    title: "Powerful and Reliable Web Development",
    description: "We develop custom web solutions using the latest technology and best practices for maximum results.",
    featuresTitle: "Cutting-edge Technical Solutions",
    featuresDescription: "We offer diverse programming solutions for all your needs",
    features: {
      customProgramming: {
        title: "Custom Programming",
        description: "We program solutions specifically designed for your needs."
      },
      backend: {
        title: "Powerful Backend Systems",
        description: "We build reliable and scalable backend systems for your web solution."
      },
      cloud: {
        title: "Cloud Solutions",
        description: "We utilize the latest technology in cloud services for maximum performance."
      },
      security: {
        title: "Security First",
        description: "We ensure the security of data and systems with best practices."
      },
      api: {
        title: "API Development",
        description: "We develop powerful APIs for integration with other systems."
      },
      performance: {
        title: "Speed and Performance",
        description: "We focus on fast and efficient systems."
      }
    },
    technologiesTitle: "Our Technology Stack",
    technologiesDescription: "We use the latest technology and tools to create the best possible solutions",
    technologies: {
      frontend: {
        title: "Frontend Development",
        description: "React, Next.js, Vue.js, TypeScript, Tailwind CSS"
      },
      backend: {
        title: "Backend Development",
        description: "Node.js, Python, PostgreSQL, MongoDB"
      },
      cloud: {
        title: "Cloud Solutions",
        description: "AWS, Google Cloud, Azure, Vercel"
      },
      database: {
        title: "Databases",
        description: "PostgreSQL, MySQL, MongoDB, Redis"
      },
      devops: {
        title: "DevOps",
        description: "Docker, Kubernetes, CI/CD, Git"
      }
    },
    processTitle: "Our Development Process",
    processDescription: "We follow a proven process to ensure a successful web solution",
    process: {
      step1: {
        title: "Analysis and Planning",
        description: "We analyze your needs and plan the project in detail."
      },
      step2: {
        title: "Design and Development",
        description: "We design and develop the web solution according to your needs."
      },
      step3: {
        title: "Testing and Quality Control",
        description: "We thoroughly test all solutions to ensure quality and reliability."
      },
      step4: {
        title: "Launch and Follow-up",
        description: "We launch the solution and provide ongoing support."
      }
    },
    benefitsTitle: "Benefits of Custom Solutions",
    benefitsDescription: "Custom solutions create competitive advantage and maximum efficiency",
    benefits: {
      benefit1: {
        title: "Tailored to Your Needs",
        description: "Solutions specifically designed for your business."
      },
      benefit2: {
        title: "Scalability",
        description: "Systems that can grow with your business without issues."
      },
      benefit3: {
        title: "Integration",
        description: "Easy integration with existing systems and processes."
      },
      benefit4: {
        title: "Competitive Advantage",
        description: "Custom solutions can give your business a competitive edge."
      },
      benefit5: {
        title: "Better User Experience",
        description: "Tailored interfaces that perfectly suit your users."
      },
      benefit6: {
        title: "Cost Efficiency",
        description: "Lower total cost of ownership in the long run."
      }
    },
    cta: {
      title: "Ready to start your project?",
      description: "Let us help you develop a powerful and reliable web solution that meets your needs",
      button: "Get a quote for development"
    }
  },
  es: {
    title: "Desarrollo Web Potente y Confiable",
    description: "Desarrollamos soluciones web personalizadas utilizando la última tecnología y las mejores prácticas para obtener resultados máximos.",
    featuresTitle: "Soluciones Técnicas de Vanguardia",
    featuresDescription: "Ofrecemos diversas soluciones de programación para todas sus necesidades",
    features: {
      customProgramming: {
        title: "Programación Personalizada",
        description: "Programamos soluciones específicamente diseñadas para sus necesidades."
      },
      backend: {
        title: "Sistemas Backend Potentes",
        description: "Construimos sistemas backend confiables y escalables para su solución web."
      },
      cloud: {
        title: "Soluciones en la Nube",
        description: "Utilizamos la última tecnología en servicios en la nube para un rendimiento máximo."
      },
      security: {
        title: "Seguridad Primero",
        description: "Garantizamos la seguridad de los datos y sistemas con las mejores prácticas."
      },
      api: {
        title: "Desarrollo de API",
        description: "Desarrollamos potentes API para la integración con otros sistemas."
      },
      performance: {
        title: "Velocidad y Rendimiento",
        description: "Nos centramos en sistemas rápidos y eficientes."
      }
    },
    technologiesTitle: "Nuestro Stack Tecnológico",
    technologiesDescription: "Utilizamos las últimas tecnologías y herramientas para crear las mejores soluciones posibles",
    technologies: {
      frontend: {
        title: "Desarrollo Frontend",
        description: "React, Next.js, Vue.js, TypeScript, Tailwind CSS"
      },
      backend: {
        title: "Desarrollo Backend",
        description: "Node.js, Python, PostgreSQL, MongoDB"
      },
      cloud: {
        title: "Soluciones en la Nube",
        description: "AWS, Google Cloud, Azure, Vercel"
      },
      database: {
        title: "Bases de Datos",
        description: "PostgreSQL, MySQL, MongoDB, Redis"
      },
      devops: {
        title: "DevOps",
        description: "Docker, Kubernetes, CI/CD, Git"
      }
    },
    processTitle: "Nuestro Proceso de Desarrollo",
    processDescription: "Seguimos un proceso probado para garantizar una solución web exitosa",
    process: {
      step1: {
        title: "Análisis y Planificación",
        description: "Analizamos sus necesidades y planificamos el proyecto en detalle."
      },
      step2: {
        title: "Diseño y Desarrollo",
        description: "Diseñamos y desarrollamos la solución web de acuerdo con sus necesidades."
      },
      step3: {
        title: "Pruebas y Control de Calidad",
        description: "Probamos exhaustivamente todas las soluciones para garantizar la calidad y la confiabilidad."
      },
      step4: {
        title: "Lanzamiento y Seguimiento",
        description: "Lanzamos la solución y proporcionamos soporte continuo."
      }
    },
    benefitsTitle: "Beneficios de las Soluciones Personalizadas",
    benefitsDescription: "Las soluciones personalizadas crean ventaja competitiva y máxima eficiencia",
    benefits: {
      benefit1: {
        title: "Adaptado a Sus Necesidades",
        description: "Soluciones específicamente diseñadas para su empresa."
      },
      benefit2: {
        title: "Escalabilidad",
        description: "Sistemas que pueden crecer con su empresa sin problemas."
      },
      benefit3: {
        title: "Integración",
        description: "Fácil integración con sistemas y procesos existentes."
      },
      benefit4: {
        title: "Ventaja Competitiva",
        description: "Las soluciones personalizadas pueden dar a su empresa una ventaja competitiva."
      },
      benefit5: {
        title: "Mejor Experiencia de Usuario",
        description: "Interfaces a medida que se adaptan perfectamente a sus usuarios."
      },
      benefit6: {
        title: "Eficiencia de Costos",
        description: "Menor costo total de propiedad a largo plazo."
      }
    },
    cta: {
      title: "¿Listo para comenzar su proyecto?",
      description: "Permítanos ayudarle a desarrollar una solución web potente y confiable que satisfaga sus necesidades",
      button: "Obtener un presupuesto para desarrollo"
    }
  },
  da: {
    title: "Kraftfuld og Pålidelig Webudvikling",
    description: "Vi udvikler tilpassede webløsninger ved hjælp af den nyeste teknologi og bedste praksis for maksimale resultater.",
    featuresTitle: "Banebrydende Tekniske Løsninger",
    featuresDescription: "Vi tilbyder forskellige programmeringsløsninger til alle dine behov",
    features: {
      customProgramming: {
        title: "Tilpasset Programmering",
        description: "Vi programmerer løsninger, der er specielt designet til dine behov."
      },
      backend: {
        title: "Kraftfulde Backend-systemer",
        description: "Vi bygger pålidelige og skalerbare backend-systemer til din webløsning."
      },
      cloud: {
        title: "Cloud-løsninger",
        description: "Vi udnytter den nyeste teknologi inden for cloud-tjenester for maksimal ydeevne."
      },
      security: {
        title: "Sikkerhed Først",
        description: "Vi sikrer data- og systemsikkerhed med bedste praksis."
      },
      api: {
        title: "API-udvikling",
        description: "Vi udvikler kraftfulde API'er til integration med andre systemer."
      },
      performance: {
        title: "Hastighed og Ydeevne",
        description: "Vi fokuserer på hurtige og effektive systemer."
      }
    },
    technologiesTitle: "Vores Teknologistak",
    technologiesDescription: "Vi bruger den nyeste teknologi og værktøjer til at skabe de bedst mulige løsninger",
    technologies: {
      frontend: {
        title: "Frontend-udvikling",
        description: "React, Next.js, Vue.js, TypeScript, Tailwind CSS"
      },
      backend: {
        title: "Backend-udvikling",
        description: "Node.js, Python, PostgreSQL, MongoDB"
      },
      cloud: {
        title: "Cloud-løsninger",
        description: "AWS, Google Cloud, Azure, Vercel"
      },
      database: {
        title: "Databaser",
        description: "PostgreSQL, MySQL, MongoDB, Redis"
      },
      devops: {
        title: "DevOps",
        description: "Docker, Kubernetes, CI/CD, Git"
      }
    },
    processTitle: "Vores Udviklingsproces",
    processDescription: "Vi følger en gennemprøvet proces for at sikre en vellykket webløsning",
    process: {
      step1: {
        title: "Analyse og Planlægning",
        description: "Vi analyserer dine behov og planlægger projektet i detaljer."
      },
      step2: {
        title: "Design og Udvikling",
        description: "Vi designer og udvikler webløsningen i henhold til dine behov."
      },
      step3: {
        title: "Test og Kvalitetskontrol",
        description: "Vi tester grundigt alle løsninger for at sikre kvalitet og pålidelighed."
      },
      step4: {
        title: "Lancering og Opfølgning",
        description: "Vi lancerer løsningen og yder løbende support."
      }
    },
    benefitsTitle: "Fordele ved Tilpassede Løsninger",
    benefitsDescription: "Tilpassede løsninger skaber konkurrencefordel og maksimal effektivitet",
    benefits: {
      benefit1: {
        title: "Skræddersyet til Dine Behov",
        description: "Løsninger specielt designet til din virksomhed."
      },
      benefit2: {
        title: "Skalerbarhed",
        description: "Systemer, der kan vokse med din virksomhed uden problemer."
      },
      benefit3: {
        title: "Integration",
        description: "Nem integration med eksisterende systemer og processer."
      },
      benefit4: {
        title: "Konkurrencefordel",
        description: "Tilpassede løsninger kan give din virksomhed en konkurrencefordel."
      },
      benefit5: {
        title: "Bedre Brugeroplevelse",
        description: "Skræddersyede grænseflader, der passer perfekt til dine brugere."
      },
      benefit6: {
        title: "Omkostningseffektivitet",
        description: "Lavere samlede ejeromkostninger på lang sigt."
      }
    },
    cta: {
      title: "Klar til at starte dit projekt?",
      description: "Lad os hjælpe dig med at udvikle en kraftfuld og pålidelig webløsning, der opfylder dine behov",
      button: "Få et tilbud på udvikling"
    }
  }
};